export enum KeyCode {
  A = 65,
  B = 66,
  C = 67,
  D = 68,
  E = 69,
  F = 70,
  H = 72,
  M = 77,
  N = 78,
  P = 80,
  S = 83,
  T = 84,
  U = 85,
  V = 86,
  TAB = 9,
  Alt = 18,
  Ctrl = 17,
  Shift = 16,
  Delete = 46,
  Backspace = 8,
  ForwardSlash = 191,
  Escape = 27
}
